import type { CSSProperties, MouseEvent, ReactNode } from "react";

import { ButtonContent, getButtonClassName, type ButtonContentAlign } from "./buttonShared";

type BaseButtonProps = {
    icon?: string;
    disabled?: boolean;
    children?: ReactNode;
    onClick?: (event: MouseEvent<HTMLElement>) => void;
    type?: "button" | "submit";
    className?: string;
    contentAlign?: ButtonContentAlign;
    showArrow?: boolean;
    style?: CSSProperties;
};

export default function BaseButton({
    icon,
    disabled = false,
    children,
    onClick,
    type = "button",
    className,
    contentAlign = "left",
    showArrow = true,
    style,
}: BaseButtonProps) {
    const buttonClassName = getButtonClassName({ disabled, className, contentAlign });

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        if (disabled) {
            event.preventDefault();
            return;
        }

        onClick?.(event);
    };

    return (
        <button
            className={buttonClassName}
            disabled={disabled}
            onClick={handleClick}
            style={style}
            type={type}
        >
            <ButtonContent icon={icon} showArrow={showArrow}>{children}</ButtonContent>
        </button>
    );
}
